import React from 'react';
import { useIntl } from 'react-intl';

import { Layout } from '@components/layout';
import { ContactView } from '@components/contactView';

const Contact = () => {
  const intl = useIntl();
  const headerTitle = intl.formatMessage({ id: 'contact.headerTitle', defaultMessage: 'Contact PLATFORM' });
  const headerDescription = intl.formatMessage({
    id: 'contact.headerDescription',
    defaultMessage: 'Get more information on how to contact PLATFORM on this page.',
  });

  return (
    <Layout title={headerTitle} defaultDescription={headerDescription}>
      <ContactView />
    </Layout>
  );
};

export default Contact;
